var CacheItem, Promise, lruCache;

Promise = require('bluebird');

lruCache = require('lru-cache');

CacheItem = require('./cache-item');

module.exports = function(opts) {
  var cache;
  cache = lruCache(opts);
  cache.getAsync = function(key, fetchFunction) {
    var item;
    item = cache.get(key);
    if (item === void 0 && fetchFunction) {
      item = new CacheItem({
        key: key,
        fetchFunction: fetchFunction
      });
      cache.set(key, item);
    }
    if (!(item instanceof CacheItem)) {
      return Promise.resolve(item);
    }
    return item.fetch();
  };
  return cache;
};
